import {
  KoForm,
  KoFormBuilder,
  KoInput,
  KoSelect,
  KoSwitch
} from 'packages';
import {
  METRIC_TYPE_OPTIONS,
  ALERT_CONDITION_OPTIONS,
  ALERT_DURATION_OPTIONS,
  ALERT_SEVERITY_OPTIONS,
  ENVIRONMENT_OPTIONS
} from '../../constants';

function AlertRuleCrud({ form, handleFinish, channels = [], services = [] }) {
  const SeverityWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select severity' options={ALERT_SEVERITY_OPTIONS} />
  );

  const MetricWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select metric' options={METRIC_TYPE_OPTIONS} />
  );

  const ConditionWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Condition' options={ALERT_CONDITION_OPTIONS} />
  );

  const DurationWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Duration' options={ALERT_DURATION_OPTIONS} />
  );

  const EnvironmentWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Environment' options={ENVIRONMENT_OPTIONS} />
  );

  const ServiceWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select service' options={services} allowClear />
  );

  const ChannelsWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} mode='multiple' placeholder='Select channels' options={channels} />
  );

  const EnabledWidget = ({ value, onChange }) => (
    <KoSwitch checked={value} onChange={onChange} />
  );

  const meta = {
    columns: 4,
    formItemLayout: null,
    colon: true,
    fields: [
      { key: 'name', label: 'Alert Name', colSpan: 2, widget: KoInput, required: true, widgetProps: { placeholder: 'e.g. High Error Rate' } },
      { key: 'severity', label: 'Severity', colSpan: 2, widget: SeverityWidget, forwardRef: true, required: true },
      { key: 'metric', label: 'Metric', colSpan: 2, widget: MetricWidget, forwardRef: true, required: true },
      { key: 'service', label: 'Service', colSpan: 2, widget: ServiceWidget, forwardRef: true },
      { key: 'condition', label: 'Condition', colSpan: 1, widget: ConditionWidget, forwardRef: true, required: true },
      { key: 'threshold', label: 'Threshold', colSpan: 1, widget: KoInput, required: true, widgetProps: { type: 'number', placeholder: '0' } },
      { key: 'duration', label: 'For Duration', colSpan: 1, widget: DurationWidget, forwardRef: true },
      { key: 'enabled', label: 'Enabled', colSpan: 1, widget: EnabledWidget, forwardRef: true },
      { key: 'environment', label: 'Environment', colSpan: 2, widget: EnvironmentWidget, forwardRef: true },
      { key: 'channels', label: 'Notification Channels', colSpan: 2, widget: ChannelsWidget, forwardRef: true },
      { key: 'description', label: 'Description', colSpan: 4, widget: KoInput.TextArea, widgetProps: { rows: 2, placeholder: 'Describe the alert rule...' } }
    ]
  };

  return (
    <KoForm form={form} layout='vertical' onFinish={handleFinish}>
      <KoFormBuilder form={form} meta={meta} />
    </KoForm>
  );
}

export default AlertRuleCrud;
